<template>
  <div>
    <div v-if="type == 'select'">
      <div v-if="!isArrayString">
        <Select v-model="dictValue" v-bind="$attrs" @on-change="change">
          <Option :value="item.key" v-for="(item,index) in dictArr" :key="index">{{item.val}}</Option>
        </Select>
      </div>
      <div v-else>
        <Select v-model="dictValue" v-bind="$attrs" @on-change="change">
          <Option :value="item" v-for="(item,index) in dictArr" :key="index">{{item}}</Option>
        </Select>
      </div>
    </div>
    <div v-else-if="type == 'button'">
      <ButtonGroup>
        <Button :type="dictValue == item.key ? 'info':'default'" @click="change(item.key)" v-for="item in dictArr" :key="item.key">{{item.val}}</Button>
      </ButtonGroup>
    </div>
    <div v-else>
      <slot :dictValue="dictValue" :dictArr="dictArr"></slot>
    </div>
  </div>
</template>
<script>
  import { dict } from '@/libs'
  import lodash from 'lodash'
  export default {
    model: { prop: 'value', event: 'change' },
    props: {
      value: String,
      /**
       * String:词典格式
       * Array:[{key:'',val:'}] || ['val','val']格式
       * Object:{key:val}格式
       */
      dict: { type: [String, Array, Object], required: true },
      type: { type: String, default: 'select' },
      showContents: { type: Array },
    },
    data() {
      return {
        isArrayString: false,
        dictArr: []
      }
    },
    computed: {
      dictValue: {
        get() {
          return this.value
        },
        set(val) {}
      }
    },
    watch: {
      dict(val) {
        this.initDictArr()
      }
    },
    methods: {
      change(item) {
        if (this.$attrs['label-in-value']) {
          this.dictValue = item.value
          this.$emit('change', item.value)
        } else {
          this.dictValue = item
          this.$emit('change', item)
        }
        this.$emit('on-change', item)
      },
      initDictArr() {
        if (typeof this.dict == 'string') {
          dict.dict(this.dict).then(payload => {
            if(this.showContents) this.dictArr = lodash.sortBy(this.showContents.map(key => { return { key, val: payload.content[key] } }), item => item.key)
            else this.dictArr = lodash.sortBy(Object.keys(payload.content).map(key => { return { key, val: payload.content[key] } }), item => item.key)
          })
        } else if (this.dict instanceof Object) {
          this.dictArr = lodash.sortBy(Object.keys(this.dict).map(key => { return { key, val: this.dict[key] } }), item => item.key)
        } else {
          this.dictArr = this.dict
        }
        this.isArrayString = this.dictArr[0] && typeof this.dictArr[0] == 'string'
      }
    },
    created() {
      this.initDictArr()
    }
  }
</script>